import { LocationData } from "../../../types/data";

// COFNAC GDY BEDA EANY STALEJ DLUGOSCI
// export const calculateEanTotals = (data: LocationData[] | undefined): Map<string, number> => {
//   const eanTotals = new Map<string, number>();

//   if (data) {
//     data.forEach((location) => {
//       location.results.forEach((res) => {
//         const current = eanTotals.get(res.ean) || 0;
//         eanTotals.set(res.ean, current + res.quantity);
//       });
//     });
//   }

//   return eanTotals;
// };

export const calculateEanTotals = (data: LocationData[] | undefined, searchPhrases: string[]) => {
  if (!data) return {};

  const totals: Record<string, number> = {};

  // Inicjalizujemy licznik dla każdej szukanej frazy (np. "0123")
  searchPhrases.forEach((phrase) => {
    totals[phrase] = 0;
  });

  data.forEach((location) => {
    location.results.forEach((result) => {
      // Sprawdzamy, do której frazy wyszukiwania pasuje ten konkretny EAN z bazy
      searchPhrases.forEach((phrase) => {
        if (result.ean.endsWith(phrase)) {
          totals[phrase] += result.quantity;
        }
      });
    });
  });

  return totals;
};

export const getUniqueEansCount = (data: LocationData[] | undefined): number => {
  if (!data) return 0;
  const allFoundEans = data.flatMap((item) => item.results.map((r) => r.ean));
  return new Set(allFoundEans).size;
};
